import { render } from "./TabsPage.vue?vue&type=template&id=396ea098"
import script from "./TabsPage.vue?vue&type=script&lang=js"
export * from "./TabsPage.vue?vue&type=script&lang=js"

import "./TabsPage.vue?vue&type=style&index=0&id=396ea098&lang=scss"

import exportComponent from "/var/www/m.lexxy.app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__